import "core-js/modules/es.number.constructor";
//
//
//
//
//
//
//
//
//
import CommonTitle from '../common/CommonTitle/CommonTitle.vue';
export default {
  props: {
    num: {
      type: Number,
      default: 3
    }
  },
  components: {
    CommonTitle: CommonTitle
  },
  computed: {
    list: function list() {
      return window.setting.惊喜时刻.话题列表 || [];
    }
  }
};